// @ts-nocheck

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';

const MagicImpersonationCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleMagicLinkCallback = async () => {
      try {
        console.log('🔍 Processing magic link callback for impersonation');
        
        // Get the URL parameters (not hash parameters)
        const urlParams = new URLSearchParams(window.location.search);
        const accessToken = urlParams.get('access_token');
        const refreshToken = urlParams.get('refresh_token');
        
        // Also check hash parameters as fallback
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const hashAccessToken = hashParams.get('access_token');
        const hashRefreshToken = hashParams.get('refresh_token');
        
        const finalAccessToken = accessToken || hashAccessToken;
        const finalRefreshToken = refreshToken || hashRefreshToken;
        
        if (!finalAccessToken || !finalRefreshToken) {
          console.error('❌ Missing tokens in magic link callback');
          toast.error('Invalid impersonation link');
          navigate('/parent-dashboard');
          return;
        }

        console.log('✅ Found tokens, setting impersonation session');
        
        // Set the session with the tokens from the magic link
        const { error } = await supabase.auth.setSession({
          access_token: finalAccessToken,
          refresh_token: finalRefreshToken,
        });

        if (error) {
          console.error('❌ Failed to set impersonation session:', error);
          toast.error('Failed to start impersonation session');
          navigate('/parent-dashboard');
          return;
        }

        console.log('✅ Impersonation session established, redirecting to athlete dashboard');
        toast.success('Successfully accessing athlete dashboard');
        
        // Redirect to athlete dashboard
        navigate('/athlete-dashboard');
        
      } catch (error) {
        console.error('💥 Error during magic link callback:', error);
        toast.error('Failed to process impersonation link');
        navigate('/parent-dashboard');
      }
    };

    handleMagicLinkCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-gray-600">Setting up athlete access...</p>
      </div>
    </div>
  );
};

export default MagicImpersonationCallback;